angular.module 'zc.core'

.controller 'AdminHeaderCtrl', ($scope, currentUser, Project, Environment) ->

  $scope.currentUser = currentUser
  $scope.Project = Project

  $scope.notification = true
  $scope.switchNotification = ->
    $scope.notification = !$scope.notification

  $scope.environment = 'production'
  Environment.get()
  .then (env) ->
    $scope.environment = env



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/controllers/admin_header.js.coffee